(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const documentElement = document.documentElement;
  const revealSelector = [
    '[data-gs-reveal]',
    '.hero__content > *',
    '.section-heading',
    '.trust-item',
    '.collection-card',
    '.colour-card',
    '.occasion-slider__header',
    '.occasion-slider__item',
    '.gs-occasion-videos__header',
    '.gs-occasion-video-card',
    '.heritage__visual',
    '.heritage__content',
    '.why-card',
    '.wholesale-cta__inner > *',
    '.faq-intro',
    '.faq-item',
    '.local-content__grid > *',
    '.contact-page__grid > *',
    '.gs-checkout__intro > *',
    '.gs-checkout__bag',
    '.gs-checkout__sidebar',
    '.gs-checkout-assurance > *',
    '.gs-checkout-empty > *'
  ].join(',');

  let observer;

  const getObserver = () => {
    if (observer || !('IntersectionObserver' in window)) return observer;
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('gs-is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    return observer;
  };

  const prepareRevealItems = (root = document) => {
    if (reducedMotion.matches) return;
    documentElement.classList.add('gs-motion-ready');
    const activeObserver = getObserver();
    const items = root.matches?.(revealSelector)
      ? [root, ...root.querySelectorAll(revealSelector)]
      : [...root.querySelectorAll(revealSelector)];

    items.forEach((item, index) => {
      if (item.dataset.gsRevealReady === 'true') return;
      item.dataset.gsReveal = '';
      item.dataset.gsRevealReady = 'true';
      item.style.setProperty('--gs-reveal-delay', `${Math.min(index % 4, 3) * 70}ms`);

      if (activeObserver) activeObserver.observe(item);
      else item.classList.add('gs-is-visible');
    });
  };

  const header = document.querySelector('.site-header');
  const progress = document.querySelector('[data-gs-scroll-progress]');
  let scrollFrame;

  const renderScrollState = () => {
    scrollFrame = undefined;
    const scrollTop = window.scrollY || documentElement.scrollTop;
    header?.classList.toggle('gs-is-scrolled', scrollTop > 18);

    if (progress) {
      const scrollRange = Math.max(1, documentElement.scrollHeight - window.innerHeight);
      progress.style.transform = `scaleX(${Math.min(1, Math.max(0, scrollTop / scrollRange))})`;
    }
  };

  const requestScrollRender = () => {
    if (scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(renderScrollState);
  };

  const closeDesktopMenus = (event) => {
    document.querySelectorAll('.desktop-nav details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
    document.querySelectorAll('.header-search[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  };

  const closeHeaderLayers = () => {
    document.querySelectorAll('.desktop-nav details[open], .header-search[open]').forEach((details) => details.removeAttribute('open'));
  };

  document.querySelectorAll('.header-search').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      document.querySelectorAll('.desktop-nav details[open]').forEach((menu) => menu.removeAttribute('open'));
      window.setTimeout(() => details.querySelector('input[type="search"]')?.focus(), 30);
    });
  });

  document.querySelectorAll('.desktop-nav details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      document.querySelectorAll('.desktop-nav details[open]').forEach((menu) => {
        if (menu !== details) menu.removeAttribute('open');
      });
      document.querySelectorAll('.header-search[open]').forEach((search) => search.removeAttribute('open'));
    });
  });

  document.querySelectorAll('[data-sgai-open]').forEach((button) => {
    button.addEventListener('click', () => {
      closeHeaderLayers();
      button.closest('.mobile-menu')?.removeAttribute('open');
    });
  });

  document.querySelectorAll('.mobile-menu__panel a').forEach((link) => {
    link.addEventListener('click', () => link.closest('.mobile-menu')?.removeAttribute('open'));
  });

  prepareRevealItems();
  renderScrollState();

  window.addEventListener('scroll', requestScrollRender, { passive: true });
  window.addEventListener('resize', requestScrollRender, { passive: true });
  document.addEventListener('pointerdown', closeDesktopMenus);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeHeaderLayers();
  });
  document.addEventListener('shopify:section:load', (event) => prepareRevealItems(event.target));
})();
